import { useEffect, useMemo, useState } from 'react';

export const rem = (input: number | string): number | string => {
  const value = typeof input === 'string' ? parseInt(input, 10) : input;
  if (Number.isNaN(value)) {
    console.error('The input of rem function is not valid!');
    return input;
  }
  return `${value / 16}rem`;
};

export function useObjectMemo<T extends object>(obj: T): T {
  return useMemo(() => {
    return obj;
  }, Object.values(obj));
}

export function isEqual(a: any, b: any) {
  if (Array.isArray(a) && Array.isArray(b)) {
    return a.length === b.length && [...a].every((val) => [...b].includes(val));
  }
  if (typeof a === 'object' && typeof b === 'object') {
    let isEqualObjects = true;
    Object.keys(a).forEach((key: any) => {
      if (!isEqual(a[key], b[key])) {
        isEqualObjects = false;
      }
    });
    Object.keys(b).forEach((key: any) => {
      if (!isEqual(b[key], a[key])) {
        isEqualObjects = false;
      }
    });
    return isEqualObjects;
  }
  return a === b;
}

// https://usehooks-ts.com/react-hook/use-debounce
export function useDebounce<T>(value: T, delay?: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay || 500);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}

export function getDataAttributes(attributes: Record<string, any>) {
  return Object.keys(attributes).reduce(
    (acc, key) => {
      if (key.startsWith('data-')) {
        acc[key] = attributes[key as any];
      }

      return acc;
    },
    {} as { [key: string]: string | boolean },
  );
}
